export default class Scroller {
  constructor() {
    this.scrollTrigger = 132;

    this.currentPosition = 0;

    // Scroll variables
    this.prevScroll = window.scrollY || document.documentElement.scrollTop;
    this.curScroll = 0;
    this.direction = 0;
    this.prevDirection = 0;

    this.onLoad();
    this.onScroll();
  }

  // Fires on load events
  onLoad() {
    this.toggleBodyClass();
    // this.toggleLogoClass();
  }

  // Fires on scroll events
  onScroll() {
    document.addEventListener('scroll', (e) => {
      this.currentPosition = window.scrollY; // update position

      this.getScrollDirection();
      this.toggleBodyClass();
      // this.toggleLogoClass();

      if (this.direction !== this.prevDirection) {
        this.toggleHeader();
      }

    });
  }

  // Toggle logo class on body based scroll currentPosition
  toggleLogoClass() {

    const featuredMedia = document.getElementById('featured-media');

    // Return if desktop or document has no image
    if(!featuredMedia || window.matchMedia('(min-width: 991px)').matches || !document.body.classList.contains('has-featured')) {
      return;
    }

    if(this.currentPosition <= (featuredMedia.offsetHeight - 36)) {
      document.body.classList.add('logo-white');
    } else {
      document.body.classList.remove('logo-white');
    }
  }

  // Toggle body class when is scrolld
  toggleBodyClass() {
    if(this.currentPosition > this.scrollTrigger) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }


  /**
   * Get scroll direction
   * 0: initial
   * 1: Up
   * 2: Down
   */
  getScrollDirection() {
    this.curScroll = window.scrollY || document.documentElement.scrollTop;
    this.direction = (this.curScroll > this.prevScroll) ? 2 : 1;
    this.prevScroll = this.curScroll;
  }

  toggleHeader() {
    // Hide header
    if (this.direction === 2 && this.curScroll > this.scrollTrigger) {
      document.body.classList.add('header--hidden');
      this.prevDirection = this.direction;
    }
    // Show header
    else if (this.direction === 1) {
      document.body.classList.remove('header--hidden');
      this.prevDirection = this.direction;
    }
  };
}
